import styles from "@/styles/Header.module.scss";
import ActiveLink from "@/components/ActiveLink";
import ScrollMenu from "@/components/ScrollMenu";
import { useAuthUserQuery, useAdultModeQuery } from "@/hooks";
import routes from "@/lib/routes";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

function AuthorizedPrimaryNavigationForSp(_ref) {
  var loggedIn = _ref.loggedIn,
      adultMode = _ref.adultMode;
  if (!loggedIn) return null;
  return /*#__PURE__*/_jsx("div", {
    className: styles.primaryNavigationForSp,
    children: /*#__PURE__*/_jsxs(ScrollMenu, {
      className: styles.primaryNavigationForSpInner,
      children: [/*#__PURE__*/_jsx("div", {
        className: "".concat(styles.slideItem, " ").concat(styles.homeLink),
        children: /*#__PURE__*/_jsx(ActiveLink, {
          href: routes.home,
          children: /*#__PURE__*/_jsx("a", {
            className: styles.slideItemLink,
            children: /*#__PURE__*/_jsx("span", {
              children: "\u30DB\u30FC\u30E0"
            })
          })
        })
      }), !adultMode && /*#__PURE__*/_jsx("div", {
        className: styles.slideItem,
        children: /*#__PURE__*/_jsx(ActiveLink, {
          href: routes.valuePlan,
          matchtype: "partial",
          children: /*#__PURE__*/_jsx("a", {
            className: styles.menuContLink,
            children: /*#__PURE__*/_jsx("span", {
              children: "\u30D0\u30EA\u30E5\u30FC\u30D7\u30E9\u30F3"
            })
          })
        })
      }), adultMode && /*#__PURE__*/_jsx("div", {
        className: styles.slideItem,
        children: /*#__PURE__*/_jsx(ActiveLink, {
          href: routes.adultEx,
          matchtype: "partial",
          children: /*#__PURE__*/_jsx("a", {
            className: styles.slideItemLink,
            children: /*#__PURE__*/_jsx("span", {
              children: "\u898B\u653E\u984C\uFF01EX"
            })
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles.slideItem,
        children: /*#__PURE__*/_jsx(ActiveLink, {
          href: routes.channels,
          matchtype: "partial",
          ignore: routes.adultEx,
          children: /*#__PURE__*/_jsx("a", {
            className: styles.slideItemLink,
            children: /*#__PURE__*/_jsx("span", {
              children: "\u6708\u984D\u5546\u54C1"
            })
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles.slideItem,
        children: /*#__PURE__*/_jsx(ActiveLink, {
          href: routes.store,
          matchtype: "partial",
          children: /*#__PURE__*/_jsx("a", {
            className: styles.slideItemLink,
            children: /*#__PURE__*/_jsx("span", {
              children: "\u5358\u54C1\u5546\u54C1"
            })
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles.slideItem,
        children: /*#__PURE__*/_jsx(ActiveLink, {
          href: routes.myList,
          matchtype: "partial",
          children: /*#__PURE__*/_jsx("a", {
            className: styles.slideItemLink,
            children: /*#__PURE__*/_jsx("span", {
              children: "\u30DE\u30A4\u30EA\u30B9\u30C8"
            })
          })
        })
      })]
    })
  });
}

function NotAuthorizedPrimaryNavigationForSp(_ref2) {
  var loggedIn = _ref2.loggedIn,
      adultMode = _ref2.adultMode;
  if (loggedIn) return null;
  return /*#__PURE__*/_jsx("div", {
    className: styles.primaryNavigationForSp,
    children: /*#__PURE__*/_jsxs(ScrollMenu, {
      className: styles.primaryNavigationForSpInner,
      children: [/*#__PURE__*/_jsx("div", {
        className: "".concat(styles.slideItem, " ").concat(styles.homeLink),
        children: /*#__PURE__*/_jsx(ActiveLink, {
          href: routes.home,
          children: /*#__PURE__*/_jsx("a", {
            className: styles.slideItemLink,
            children: /*#__PURE__*/_jsx("span", {
              children: "\u30DB\u30FC\u30E0"
            })
          })
        })
      }), !adultMode && /*#__PURE__*/_jsx("div", {
        className: styles.slideItem,
        children: /*#__PURE__*/_jsx(ActiveLink, {
          href: routes.valuePlan,
          matchtype: "partial",
          children: /*#__PURE__*/_jsx("a", {
            className: "".concat(styles.menuContLink, " ").concat(styles.valuePlanLink),
            children: /*#__PURE__*/_jsx("span", {
              children: "\u30D0\u30EA\u30E5\u30FC\u30D7\u30E9\u30F3"
            })
          })
        })
      }), adultMode && /*#__PURE__*/_jsx("div", {
        className: styles.slideItem,
        children: /*#__PURE__*/_jsx(ActiveLink, {
          href: routes.adultEx,
          matchtype: "partial",
          children: /*#__PURE__*/_jsx("a", {
            className: styles.slideItemLink,
            children: /*#__PURE__*/_jsx("span", {
              children: "\u898B\u653E\u984C\uFF01EX"
            })
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles.slideItem,
        children: /*#__PURE__*/_jsx(ActiveLink, {
          href: routes.channels,
          matchtype: "partial",
          ignore: routes.adultEx,
          children: /*#__PURE__*/_jsx("a", {
            className: styles.slideItemLink,
            children: /*#__PURE__*/_jsx("span", {
              children: "\u6708\u984D\u5546\u54C1"
            })
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles.slideItem,
        children: /*#__PURE__*/_jsx(ActiveLink, {
          href: routes.store,
          matchtype: "partial",
          children: /*#__PURE__*/_jsx("a", {
            className: styles.slideItemLink,
            children: /*#__PURE__*/_jsx("span", {
              children: "\u5358\u54C1\u5546\u54C1"
            })
          })
        })
      })]
    })
  });
} // export default memo(PrimaryNavigation);


export default function PrimaryNavigationForSp() {
  var _ref3;

  var _useAuthUserQuery = useAuthUserQuery({
    fetchPolicy: "cache-first"
  }),
      loading = _useAuthUserQuery.loading,
      data = _useAuthUserQuery.data;

  var _useAdultModeQuery = useAdultModeQuery({
    fetchPolicy: "cache-first"
  }),
      adultModeLoading = _useAdultModeQuery.loading,
      adultModeData = _useAdultModeQuery.data;

  var loggedIn = !loading && (data === null || data === void 0 ? void 0 : data.user);
  var adultMode = (_ref3 = !adultModeLoading && (adultModeData === null || adultModeData === void 0 ? void 0 : adultModeData.adultMode)) !== null && _ref3 !== void 0 ? _ref3 : true;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(NotAuthorizedPrimaryNavigationForSp, {
      loggedIn: loggedIn,
      adultMode: adultMode
    }), /*#__PURE__*/_jsx(AuthorizedPrimaryNavigationForSp, {
      loggedIn: loggedIn,
      adultMode: adultMode
    })]
  });
}